import React, { Component } from "react";
import { connect } from "react-redux";
import { expenseGroupingsService } from "services";
import { FiPlus, FiMoreHorizontal, FiSearch } from "react-icons/fi";
import { Dropdown, FormGroup, FormControl } from "react-bootstrap";
import Layout from "components/Layout";
import Loading from "components/Loading";
import ExpenseGroupingEdit from "components/ExpenseGroupings/ExpenseGroupingEditModal";
import Modal from "components/Modal";
import DataTable from "components/DataTable/DataTable";
import { showModal, hideModal } from "actions/modalActions";
import * as expensesActions from "actions/expensesActions";
import { errorFormating } from "utils/utils";
import ExpenseNavigationTabs from "components/Expenses/ExpenseNavigationTabs";
import { withTranslation } from "react-i18next";

class ExpenseGroupings extends Component {
	constructor(props) {
		super(props);

		this.state = {
			searchExpenseGrouping: "",
		};

		this.closeModal = this.closeModal.bind(this);
		this.openNewExpenseGroupingModal = this.openNewExpenseGroupingModal.bind(this);
		this.openEditExpenseGroupingModal = this.openEditExpenseGroupingModal.bind(this);
		this.openAlertModal = this.openAlertModal.bind(this);
		this.getExpenseGroupings = this.getExpenseGroupings.bind(this);
	}

	componentDidMount() {
		this.getExpenseGroupings();
	}

	handleChangeSearch = (event) => {
		this.setState({ [event.target.id]: event.target.value }, () => {
			this.getExpenseGroupings();
		});
	};

	async getExpenseGroupings() {
		await this.props.getAllExpenseGroupings({ q: this.state.searchExpenseGrouping });
	}

	closeModal() {
		this.props.hideModal();
	}

	openNewExpenseGroupingModal() {
		const { t } = this.props;
		this.props.showModal(
			{
				open: true,
				title: t("expenseGroupings.new"),
				style: { width: "400px" },
				content: (
					<ExpenseGroupingEdit
						getExpenseGroupings={this.getExpenseGroupings}
						handleClose={this.closeModal}
					/>
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	openEditExpenseGroupingModal(expense_grouping) {
		const { t } = this.props;
		this.props.showModal(
			{
				open: true,
				title: t("expenseGroupings.edit"),
				style: { width: "400px" },
				content: (
					<ExpenseGroupingEdit
						expense_grouping={expense_grouping}
						getExpenseGroupings={this.getExpenseGroupings}
						handleClose={this.closeModal}
					/>
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	openDeleteExpenseGroupingModal(idExpenseGrouping) {
		const { t } = this.props;
		this.props.showModal(
			{
				open: true,
				title: t("expenseGroupings.delete"),
				style: { width: "400px" },
				message: t("expenseGroupings.confirmDelete"),
				deleteAction: () => this.confirmDelete(idExpenseGrouping),
				closeModal: this.closeModal,
			},
			"delete"
		);
	}

	openAlertModal(message) {
		const { t } = this.props;
		this.props.showModal(
			{
				open: true,
				title: t("common.errorDeleting"),
				style: { width: "400px" },
				message: message,
				closeModal: this.closeModal,
			},
			"alert"
		);
	}

	confirmDelete = async (idExpenseGrouping) => {
		const response = await expenseGroupingsService.remove(idExpenseGrouping);

		if (!response.ok) {
			let textError = errorFormating(response);
			this.openAlertModal(textError.id);
		} else {
			this.getExpenseGroupings();
			this.closeModal();
		}
	};

	getColumns = () => {
		const { t } = this.props;
		return [
			{
				key: "name",
				header: t("common.name"),
				render: (expense_grouping) => (
					<button
						className="btn-transparent btn-editable"
						onClick={() => this.openEditExpenseGroupingModal(expense_grouping)}
					>
						{expense_grouping.name}
					</button>
				),
			},
			{
				key: "description",
				header: t("common.description"),
			},
			{
				key: "enabled",
				header: t("common.active"),
				render: (expense_grouping) =>
					expense_grouping.enabled ? (
						<span title={t("common.active")} className="estado estado-si">
							{t("common.active")}
						</span>
					) : (
						<span title={t("common.inactive")} className="estado estado-no">
							{t("common.inactive")}
						</span>
					),
			},
			{
				key: "color",
				header: "",
				sortable: false,
				cellClassName: "td-icon",
				render: (expense_grouping) => (
					<span
						className="bolita"
						style={{
							backgroundColor: expense_grouping.background_color || undefined,
							border: expense_grouping.border_color
								? `2px solid ${expense_grouping.border_color}`
								: undefined,
						}}
					/>
				),
			},
		];
	};

	getContent = () => {
		const { t } = this.props;

		if (this.props.loading) {
			return <Loading />;
		}

		if (this.props.error) {
			return <div className="no-results">{t("expenseGroupings.errorLoading")}</div>;
		}

		return (
			<DataTable
				tableClassName="table-categories table-hover"
				columns={this.getColumns()}
				rows={this.props.expense_groupings}
				rowKey={(row) => row.id}
				emptyMessage={t("expenseGroupings.empty")}
				actionsColumn={{
					render: (expense_grouping) => (
						<Dropdown>
							<Dropdown.Toggle variant="action">
								<FiMoreHorizontal />
							</Dropdown.Toggle>
							<Dropdown.Menu>
								<Dropdown.Item
									as="button"
									onClick={() =>
										this.openEditExpenseGroupingModal(expense_grouping)
									}
								>
									{t("common.edit")}
								</Dropdown.Item>
								<Dropdown.Item
									as="button"
									onClick={() =>
										this.openDeleteExpenseGroupingModal(expense_grouping.id)
									}
								>
									{t("common.delete")}
								</Dropdown.Item>
							</Dropdown.Menu>
						</Dropdown>
					),
					className: "td-actions",
				}}
			/>
		);
	};

	render() {
		const { t } = this.props;
		return (
			<>
				<Layout
					className="page-categories"
					context="expenses"
					configSidebar={false}
				>
					<div className="heading">
						<div className="heading-left">
							<h1 className="title">{t("expenseGroupings.title")}</h1>
						</div>
						<div className="heading-filters">
							<FormGroup
								className="form-group form-search"
								controlId="searchExpenseGrouping"
							>
								<FormControl
									type="text"
									placeholder={t("common.search")}
									value={this.state.searchExpenseGrouping}
									onChange={this.handleChangeSearch}
								/>
								<FiSearch />
							</FormGroup>
						</div>
						<div className="heading-actions">
							<button
								type="button"
								title={t("expenseGroupings.create")}
								onClick={this.openNewExpenseGroupingModal}
								className="btn btn-new"
							>
								<FiPlus />
							</button>
						</div>
					</div>

					<ExpenseNavigationTabs />

					{this.getContent()}
				</Layout>

				<Modal hideModal={this.props.hideModal} />
			</>
		);
	}
}

const mapStateToProps = (reducers) => {
	return reducers.expensesReducer;
};

const mapDispatchToProps = (dispatch) => ({
	hideModal: () => dispatch(hideModal()),
	showModal: (modalProps, modalType) => {
		dispatch(showModal({ modalProps, modalType }));
	},
	getAllExpenseGroupings: (options) =>
		dispatch(expensesActions.getAllExpenseGroupings(options)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ExpenseGroupings));
